import React from 'react';

import ContentWrapper from './src/contentwrapper';
import ContactForm from './src/contactform';

import ChrisLoader from './src/loaders/chris';

import DefaultPost from './src/posts/default';
import ClientPost from './src/posts/client';
import MasonryArchive from './src/masonryarchive';

function main() {

    /*
        The remaining code below is for masonry archives
    */

    // TODO: sync with src/titlearea.jsx
    const ShadowColor = "#333";

    const MasonryTextStyle = {
        maxWidth: 'none',
        color: 'white',
        fontWeight: 600,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        fontSize: 'calc(26px + .1vw)',
        textAlign: 'center',
        textShadow: `0 0 10px ${ShadowColor}`,
        lineHeight: 1.25
    };
    const ReadMoreStyle = {
        textTransform: 'uppercase',
        textAlign: 'center',
        color: 'white',
        fontWeight: 600,
        fontSize: 'calc(10px + .5vw)',
        letterSpacing: 1.1,
        lineHeight: 3.0,
        textShadow: `0 0 10px ${ShadowColor}`,
        maxWidth: 'none'
    };

    const nl2br = str => typeof str === 'string' ? str.replace(/(\\r)?\\n/g, '<br />\n') : str;

    const {RawHTML, Image, EaseIn} = polyphony.components.generic;
    const {useHover} = polyphony.hooks;

    /*
        Masonry Tile backgrounds
        (post & client)
    */

    const TileImageStyle = {
        minHeight: '100px',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
        position: 'absolute',
        top: 0, left: 0, bottom: 0, right: 0,
        zIndex: -1
    };

    const ClientArchive = props => <InteractiveArchive {...props} backgroundColor="white" bordered />;
    const DefaultArchive = props => <InteractiveArchive {...props} backgroundColor="black" />;

    let prev = 0;
    function randomDelay() {
        let rand = prev;
        while (Math.abs(prev - rand) < 0.1) rand = Math.random() / 2;
        prev = rand;
        return rand;
    }

    const InteractiveTile = ({post}) => {
        const bp = polyphony.hooks.useBreakpoint();
        const isHome = polyphony.useState(({is}) => is.front_page);
        const animate = EaseIn.useAnimate();
        const animateDelay = () => animate(randomDelay());
        const {meta, post_type, title} = post;
        const isClient = post_type.name === 'client';
        const isPost = post_type.name === 'post';

        let jsxParts = [];
        let linkStyle = {display: 'flex', flexFlow: 'column nowrap', boxSizing: 'border-box', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', padding: 20};

        if ((isClient && isHome) || isPost) { // eslint-disable-line
            linkStyle.background = 'radial-gradient(hsla(0, 0%, 20%, 0.36), transparent)';
            const {home_masonry_title: homeTitle,
                   internal_masonry_title: internalTitle} = meta;

            let mtitle = title;
            if (isHome) {
                if (homeTitle) mtitle = homeTitle; // eslint-disable-line
            } else {
                if (internalTitle) mtitle = internalTitle; // eslint-disable-line
            }

            jsxParts.push(
                <h3 key="title" style={MasonryTextStyle}>
                    <RawHTML>{nl2br(mtitle)}</RawHTML>
                </h3>
            );
        }

        if (isClient && !isHome) {
            jsxParts.push(<Image
                             key='pc_logo'
                             media={meta.pc_logo}
                             onLoad={meta.pc_logo && meta.pc_logo.svg && bp !== 'mobile' ? animateDelay : animate}
                             style={{width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center'}} />);
        }

        if (isPost) {
            jsxParts.push(<div key="readmore" style={ReadMoreStyle}>Read More</div>);
        }

        let media = post.featured_media.default;

        if (post.meta) {
            let m = post.meta[(isHome ? 'home' : 'internal') + '_masonry_background'];
            if (m) media = m;
        }

        let img = ((post.post_type.name !== 'post' && !isHome) || !media || media.type !== 'image')
            ? bp === 'mobile' ? animate() : animateDelay()
            : <Image lazy key='media' onLoad={media && media.svg && bp !== 'mobile' ? animateDelay : animate} media={media} style={TileImageStyle} />;

        let href = post.permalink ? post.permalink : post.archive_permalink;

        return [img, <a key='link' href={href} className='pc-masonry-tile-link' style={linkStyle}>
            {jsxParts}
        </a>];
    };

    const InteractiveArchive = props => <MasonryArchive {...props} dotColor="black">
        <InteractiveTile />
    </MasonryArchive>;

    /*
        service taxonomy
    */

    const ServiceTextStyle = {
        maxWidth: 'none',
        fontWeight: 600,
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: 20,
        lineHeight: 1.25
    };

    const ServiceDescStyle = {
        textAlign: 'center',
        fontSize: 20,
        lineHeight: 1.25
    };

    const {useBreakpoint} = polyphony.hooks;

    const ServiceTile = ({post: term}) => {
        const breakpoint = useBreakpoint();
        const animate = EaseIn.useAnimate();
        const padding = polyphony.useState(s => s.measurements.services_tile_padding);

        let isMobile = breakpoint === 'mobile';
        const animateDelay = () => animate(randomDelay());

        const [{hover}, ref] = useHover();

        let onLoad = term.logo && term.logo.svg && !isMobile ? animateDelay : animate;
        let showDesc = hover && term.description;

        return <div ref={ref} className={isMobile ? undefined : 'pc-masonry-tile-link'} style={{width: '100%',
                              height: '100%',
                              display: 'flex',
                              cursor: 'default',
                              justifyContent: 'center',
                              alignItems: 'center',
                              flexFlow: 'column nowrap',
                              padding, boxSizing: 'border-box'}}>
            {isMobile
              ? <>
                    <Image media={term.logo} onLoad={onLoad} style={{maxWidth: '33%', maxHeight: '33%', marginBottom: '5%', objectFit: 'contain'}}/>
                    <div className="no-select" style={{...ServiceTextStyle, marginBottom: '5%'}}><RawHTML>{nl2br(term.name)}</RawHTML></div>
                    <div className="no-select" style={{...ServiceDescStyle, fontSize: 17}}><RawHTML>{nl2br(term.description)}</RawHTML></div>
                </>
              : <>
                {!showDesc && <Image media={term.logo} onLoad={onLoad} style={{maxWidth: '33%', maxHeight: '33%', marginBottom: '5%'}}/>}
                <div className='no-select' style={showDesc ? ServiceDescStyle : ServiceTextStyle}>
                    <RawHTML>{nl2br(showDesc ? term.description : term.name)}</RawHTML>
                </div>
            </>}
        </div>;
    };

    const ServiceArchive = props =>
        <MasonryArchive {...props} bordered backgroundColor="white" dotColor="black">
            <ServiceTile />
        </MasonryArchive>;

    polyphony.setContentWrapper(ContentWrapper);
    polyphony.setLoadingIndicator(ChrisLoader);
    polyphony.addBlock(ContactForm);
    polyphony.setPostComponent('page', DefaultPost);
    polyphony.setPostType('post', props => <DefaultPost showSharing {...props}/>, DefaultArchive); // Newsblog page
    polyphony.setPostType('client', ClientPost, ClientArchive); // Clients page
    polyphony.setTaxonomy('services', ServiceArchive); // Services page
    polyphony.setTaxonomy('industries', DefaultArchive);
    polyphony.setArchiveComponent(['client', 'post'], DefaultArchive); // Home page
}

if (window.polyphony) main();
else document.addEventListener('PolyphonyLoaded', main);

